import { z } from 'zod';
export const US_STATE_CODES = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
];
export const USStateCodeSchema = z.enum(US_STATE_CODES);
export const US_POSTAL_CODE_REGEX = /^\d{5}(?:-\d{4})?$/;
export const US_PHONE_NUMBER_REGEX = /^(?:\+?1[-.\s]?)?(?:\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/;
const AddressSchema = z.object({
    line1: z.string().min(1),
    line2: z.string().optional(),
    city: z.string().min(1),
    state: USStateCodeSchema,
    postalCode: z.string().regex(US_POSTAL_CODE_REGEX),
});
const ContactSchema = z.object({
    fullName: z.string().min(1),
    dateOfBirth: z.string().optional(),
    address: AddressSchema,
    phone: z.string().regex(US_PHONE_NUMBER_REGEX),
    email: z.string().email().optional(),
});
const SuccessorAgentSchema = ContactSchema;
export const FinancialPOAPowersSchema = z
    .object({
    realEstateTransactions: z.boolean(),
    tangiblePersonalPropertyTransactions: z.boolean(),
    bankingAndFinancialInstitutionTransactions: z.boolean(),
    businessOperatingTransactions: z.boolean(),
    insuranceAndAnnuityTransactions: z.boolean(),
    estateTrustAndBeneficiaryTransactions: z.boolean(),
    claimsAndLitigation: z.boolean(),
    personalAndFamilyMaintenance: z.boolean(),
    retirementPlanTransactions: z.boolean(),
    taxMatters: z.boolean(),
})
    .refine((powers) => Object.values(powers).some(Boolean), {
    message: 'At least one financial power must be selected.',
});
const FinancialPOAEffectivenessSchema = z.object({
    type: z.enum(['immediate', 'upon_incapacity']),
    terminationConditions: z.string().optional(),
});
const FinancialPOADeliverySchema = z.object({
    sendToAgent: z.boolean(),
    agentEmail: z.string().email().optional(),
});
export const FinancialPOAIntakeSchema = z.object({
    principal: ContactSchema,
    agent: ContactSchema,
    successorAgents: z.array(SuccessorAgentSchema),
    powers: FinancialPOAPowersSchema,
    specialInstructions: z.string().optional(),
    effectiveness: FinancialPOAEffectivenessSchema,
    delivery: FinancialPOADeliverySchema.optional(),
});
//# sourceMappingURL=poa-financial-intake.js.map